import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { service_controllers_methods } from './service_controllers_methods';
import { KeyValues10, KeyValues3, KeyValues5, LocalService, Paging, StatusWithId, Wrapper10Initialization, Wrappers5 } from './local.service';
import { HttpRequestComponent } from '../app/shared/http-request/http-request.component';

@Injectable({
  providedIn: 'root'
})
export class AuditingService {
  private controllerName = service_controllers_methods.auditing.controller;
  private methods = service_controllers_methods.auditing.methods;

  constructor(private localService: LocalService, private httpService: HttpRequestComponent) { }

  public getExpensesInitialization(filterData: KeyValues5): Observable<Wrapper10Initialization> {
    const body = {
      sel: this.localService.getSelected(),
      dt: filterData
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetExpensesInitialization, body);
  }
}
